export function validateChangePassword(values) {
  let errors = {};

  if (!values.oldPassword) {
    errors.oldPassword = 'Current password is required';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password.length < 8) {
    errors.password = 'Password must be 8 or more characters';
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Confirm Password is required';
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Password Should match';
  }

  return errors;

}

export function validateConfirmationDialog(values) {
  let errors = {};
  if (!values.reason) {
    errors.reason = 'Reason is required';
  }

  return errors;
}

export function validateConfirmationDialogNoValidation(values) {
  let errors = {};

  return errors;
}
